import React, { useState } from 'react';
import { Button, Confirm, Header, Icon, Segment } from 'semantic-ui-react';
import { cleanupEvents } from '../../services/Metrics';
import { notifError, notifSuccess } from '../Tools/NotificationToasts';

function MetricsMaintenanceSection() {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCleanup = () => {
    setLoading(true);
    setConfirmOpen(false);
    cleanupEvents()
      .then((res) => {
        setLoading(false);
        if (res.status === 200 && res.data.success) {
          notifSuccess('Événements anciens purgés avec succès.');
        } else {
          notifError('Erreur lors de la purge des événements.');
        }
      })
      .catch(() => {
        setLoading(false);
        notifError('Erreur lors de la purge des événements.');
      });
  };

  return (
    <Segment className="transparent-table" color="orange">
      <Header as="h3" color="orange">
        <Icon name="trash alternate" />
        <Header.Content>Maintenance</Header.Content>
      </Header>
      <p>Purger les anciens événements de métriques selon le TTL configuré côté serveur.</p>
      <Button
        color="orange"
        icon
        labelPosition="left"
        loading={loading}
        onClick={() => setConfirmOpen(true)}
      >
        <Icon name="trash" />
        Purger les événements anciens
      </Button>
      <Confirm
        open={confirmOpen}
        header="Purger les événements ?"
        content="Cette action supprimera les événements de métriques plus anciens que le TTL configuré. Cette opération est irréversible."
        confirmButton="Purger"
        cancelButton="Annuler"
        onConfirm={handleCleanup}
        onCancel={() => setConfirmOpen(false)}
      />
    </Segment>
  );
}

export default MetricsMaintenanceSection;
